var CDN='https://cdn.shopify.com/s/files/1/0759/3833/2928/files/';
var AUDIO_FILES={
  'atomic': CDN+'sample-summary-atomic-habits.mp3',
  'focus':  CDN+'sample-focus-session.mp3',
  'lesson': CDN+'sample-course-lesson1.mp3'
};

var fmt=function(s){if(!isFinite(s))return'--:--';s=Math.max(0,s|0);return Math.floor(s/60)+':'+String(s%60).padStart(2,'0');};
function toast(m){var t=document.getElementById('toast');t.textContent=m;t.classList.add('show');clearTimeout(t._t);t._t=setTimeout(function(){t.classList.remove('show');},1800);}

var PLAYERS=[];
document.querySelectorAll('[data-player]').forEach(function(root){
  var a=root.querySelector('audio');
  var __raw=a.getAttribute('src')||'';if(__raw&&__raw.indexOf('//')===-1){a.src=CDN+__raw.split('/').pop();}
  var playBtn=root.querySelector('[data-play]');
  var seek=root.querySelector('[data-seek]');
  var cur=root.querySelector('[data-cur]');
  var dur=root.querySelector('[data-dur]');
  var ic=function(){return playBtn.querySelector('.ic');};
  var setIcon=function(p){ic().innerHTML=p?'<rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/>':'<path d="M7 5v14l12-7z"/>';};
  var P={a:a,setIcon:setIcon};PLAYERS.push(P);
  playBtn.addEventListener('click',function(){
    if(a.paused){PLAYERS.forEach(function(o){if(o!==P){o.a.pause();}});
      a.play().catch(function(){toast('Unable to play — check browser settings');});}
    else a.pause();
  });
  a.addEventListener('play',function(){setIcon(true);});
  a.addEventListener('pause',function(){setIcon(false);});
  a.addEventListener('loadedmetadata',function(){if(dur)dur.textContent=fmt(a.duration);});
  a.addEventListener('timeupdate',function(){if(cur)cur.textContent=fmt(a.currentTime);if(a.duration&&seek)seek.value=a.currentTime/a.duration*100;});
  a.addEventListener('ended',function(){setIcon(false);if(seek)seek.value=0;});
  a.addEventListener('error',function(){if(dur)dur.textContent='—';});
  if(seek)seek.addEventListener('input',function(){if(a.duration)a.currentTime=seek.value/100*a.duration;});
  root.querySelectorAll('[data-skip]').forEach(function(b){b.addEventListener('click',function(){a.currentTime=Math.max(0,a.currentTime+ +b.dataset.skip);});});
  var sp=root.querySelector('[data-speed]');
  if(sp){var rates=[1,1.25,1.5,0.85];var si=0;sp.addEventListener('click',function(){si=(si+1)%rates.length;a.playbackRate=rates[si];sp.textContent=rates[si]+'× speed';});}
  var lp=root.querySelector('[data-loop]');
  if(lp)lp.addEventListener('click',function(){a.loop=!a.loop;lp.classList.toggle('on',a.loop);toast(a.loop?'Loop on':'Loop off');});
  var tr=root.querySelector('[data-tr]'),trbox=root.querySelector('[data-trbox]');
  if(tr&&trbox)tr.addEventListener('click',function(){trbox.classList.toggle('show');tr.classList.toggle('on');});
});

var LESSONS=[
  {t:'The 2-Minute Start',d:'Free preview · ~1 min',free:true},
  {t:'Build a Frictionless Workspace',d:'Module 2 · 12 min',free:false},
  {t:'The "One Open Loop" Rule',d:'Module 3 · 14 min',free:false},
  {t:'Body-Doubling & Accountability',d:'Module 4 · 11 min',free:false},
  {t:'Time-Blocking Without the Rigidity',d:'Module 5 · 13 min',free:false},
  {t:'Dopamine-Friendly Reward Design',d:'Module 6 · 15 min',free:false},
  {t:'Recovering After a Lost Day',d:'Module 7 · 10 min',free:false},
  {t:'Your Personal Operating System',d:'Module 8 · 16 min',free:false}
];
var done=new Set();
var list=document.getElementById('lessonList');
function renderLessons(active){
  if(active===undefined)active=0;
  list.innerHTML=LESSONS.map(function(l,i){
    return '<div class="lesson '+(i===active?'active':'')+' '+(l.free?'':'locked')+' '+(done.has(i)?'done':'')+'" onclick="selectLesson('+i+')">'+'<span class="ln">'+(done.has(i)?'✓':i+1)+'</span>'+'<span class="lt"><b>'+l.t+'</b><span>'+l.d+'</span></span>'+(l.free?'':'<span class="lock"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="11" width="16" height="9" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/></svg></span>')+'</div>';
  }).join('');
}
function selectLesson(i){
  var l=LESSONS[i];
  document.getElementById('lsTitle').textContent='Lesson '+(i+1)+' — '+l.t;
  if(l.free){
    document.getElementById('lsPlayer').style.display='';
    document.getElementById('lockedCard').style.display='none';
    document.getElementById('lsMeta').textContent='Audio · ~1 min sample · narrated';
    document.querySelector('.stage .badge').style.display='';
  }else{
    PLAYERS.forEach(function(o){o.a.pause();});
    document.getElementById('lsPlayer').style.display='none';
    document.getElementById('lockedCard').style.display='block';
    document.getElementById('lsMeta').textContent=l.d;
    document.querySelector('.stage .badge').style.display='none';
  }
  renderLessons(i);
}
function updateProg(){
  var pct=done.size/LESSONS.length*100;
  document.getElementById('cprog').style.width=pct+'%';
  document.getElementById('progTxt').textContent=done.size+' / '+LESSONS.length+' lessons';
}
document.getElementById('markDone').addEventListener('click',function(){done.add(0);renderLessons(0);updateProg();toast('Lesson 1 complete ✓ — momentum.');});
renderLessons(0);updateProg();

var speaking=false;
var speakText='Deep work is focused, undistracted effort on a hard problem, and it is becoming rare exactly as it becomes valuable. Schedule it like an appointment, kill the context switching, and treat shallow tasks as the exception, not the default.';
function toggleSpeak(){
  if(!('speechSynthesis'in window)){toast('Your browser has no built-in voice');return;}
  var btn=document.getElementById('speakBtn').querySelector('.ic');
  var st=document.getElementById('speakState');
  if(speaking){speechSynthesis.cancel();speaking=false;btn.innerHTML='<path d="M7 5v14l12-7z"/>';st.textContent='Tap to have your device read it';return;}
  var u=new SpeechSynthesisUtterance(speakText);u.rate=.96;u.pitch=1;
  u.onend=function(){speaking=false;btn.innerHTML='<path d="M7 5v14l12-7z"/>';st.textContent='Done — tap to replay';};
  PLAYERS.forEach(function(o){o.a.pause();});
  speechSynthesis.cancel();speechSynthesis.speak(u);speaking=true;
  btn.innerHTML='<rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/>';st.textContent='Reading aloud…';
}